import React, {useCallback, useEffect, useRef} from 'react';
import { useDispatch} from 'react-redux';
import ReactModalContent from '../Shared/Modal/ReactModalContent';
import ReactModalFooter from '../Shared/Modal/ReactModalFooter';
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import {useHistory} from "react-router-dom";
import {
    savePreferencesAndSubscriptions, setIsDailyPricesInvestmentError,
    setIsEditSubscriptionEmail, setIsEmailNotOnFileError, setIsMonthlyPerformanceInvestmentError
} from "../../redux/profile/slice";
import {UseAppSelector} from "../../redux/configure-store";
import {
    getAddConsentRequestData, getDailyPricesInvOption,
    getEmailAddress, getIsDailyPricesInvestmentError,
    getIsEmailNotOnFileError, getIsMonthlyPerformanceInvestmentError, getMonthlyPerformanceInvOption,
    getPutServiceCallForDailyPrices,
    getPutServiceCallForMonthlyPerformance,
    getSaveDailyPricesInvestmentoptions,
    getSaveDailyPricesPreferences,
    getSaveMonthlyPerformanceInvestmentOptions,
    getSaveMonthlyPerformancePreferences, getSelectedPerformanceServiceProducts, getSelectedPricesServiceProducts,
    getServiceProductDailyPricesRequestData,
    getServiceProductMonthlyPerformanceRequestData, getServiceStatus,
    getServiceStatusDailyPricesRequestData,
    getServiceStatusMonthlyPerformanceRequestData
} from "../../redux/profile/selectors";
import {isInternal} from "../../utils/api";

export const ConfirmSaveModal = ({modalName,handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();
    const { goBack } = useHistory();

    useEffect(() => {
        const overlay = "Do You Want to Save Your Changes?";
        dispatchOverlayLoad(overlay);
    }, []);

    const addConsentsRequestData = UseAppSelector(getAddConsentRequestData);
    const serviceStatusDailyPricesRequestData = UseAppSelector(getServiceStatusDailyPricesRequestData);
    const serviceStatusMonthlyPerformanceRequestData = UseAppSelector(getServiceStatusMonthlyPerformanceRequestData);
    const serviceProductDailyPricesRequestData = UseAppSelector(getServiceProductDailyPricesRequestData);
    const serviceProductMonthlyPerformanceRequestData = UseAppSelector(getServiceProductMonthlyPerformanceRequestData);
    const saveDailyPricesPreferences = UseAppSelector(getSaveDailyPricesPreferences);
    const saveMonthlyPerformancePreferences = UseAppSelector(getSaveMonthlyPerformancePreferences);
    const putServiceCallForDailyPrices = UseAppSelector(getPutServiceCallForDailyPrices);
    const putServiceCallForMonthlyPerformance = UseAppSelector(getPutServiceCallForMonthlyPerformance);
    const subscriptionEmailAddress = UseAppSelector(getEmailAddress);
    const isEmailNotOnFileError = UseAppSelector(getIsEmailNotOnFileError);
    const isDailyPricesInvestmentError = UseAppSelector(getIsDailyPricesInvestmentError);
    const isMonthlyPerformanceInvestmentError = UseAppSelector(getIsMonthlyPerformanceInvestmentError);
    const isDisableSaveButton = isEmailNotOnFileError || isDailyPricesInvestmentError || isMonthlyPerformanceInvestmentError || isInternal();
    const saveDailyPricesInvestmentOptions = UseAppSelector(getSaveDailyPricesInvestmentoptions);
    const saveMonthlyPerformanceInvestmentOptions = UseAppSelector(getSaveMonthlyPerformanceInvestmentOptions);
    const selectedPricesServiceProducts = UseAppSelector(getSelectedPricesServiceProducts);
    const selectedPerformanceServiceProducts = UseAppSelector(getSelectedPerformanceServiceProducts);
    const getUpdatedDailyPriceInvOption = UseAppSelector(getDailyPricesInvOption);
    const getUpdatedMonthlyPerformanceOption = UseAppSelector(getMonthlyPerformanceInvOption);
    const serviceStatus = UseAppSelector(getServiceStatus);
    const investmentOptions =
        [
            {name: "The Investment options that I invested in", value: "B", id: "option1"},
            {name: "All investment options available in my plan ", value: "C", id: "option2"},
            {name: "Select specific investment options in my plan", value: "G", id: "option3"}
        ]
    const dailyPriceServiceStatus = serviceStatus?.find((status: any) => status?.serviceOptionCode == 20);
    const defaultDailyPriceOption = dailyPriceServiceStatus ? investmentOptions.find((option: any) => option.value === dailyPriceServiceStatus?.serviceStatusCode)?.value : "B";
    const updatedDailyPriceInvOption = getUpdatedDailyPriceInvOption ? getUpdatedDailyPriceInvOption : defaultDailyPriceOption;

    const monthlyPerformanceServiceStatus = serviceStatus?.find((status: any) => status?.serviceOptionCode == 21);
    const monthlyPerformanceInvOption = monthlyPerformanceServiceStatus ? investmentOptions.find((option: any) => option.value === monthlyPerformanceServiceStatus?.serviceStatusCode)?.value : "B";
    const updatedMonthlyPerformanceOption = getUpdatedMonthlyPerformanceOption ? getUpdatedMonthlyPerformanceOption : monthlyPerformanceInvOption;

    const isDailyPricesSpecificInvestment = updatedDailyPriceInvOption === "G"? true: false;
    const isMonthlyPerformanceInvestmentSpecific =  updatedMonthlyPerformanceOption ==="G"? true: false;


    const emailAddressRef = useRef();
    const servicesAndRequest:any ={};
    const setEditSubscriptionAndEmailNotOnFileError = useCallback(() => {
        dispatch(setIsEditSubscriptionEmail(true))
        dispatch(setIsEmailNotOnFileError(true))
    }, [dispatch]);
    const onClickSaveChanges = useCallback(() => {
        let isValid = true;
        if(!subscriptionEmailAddress.trim()) {
            setEditSubscriptionAndEmailNotOnFileError();
            emailAddressRef.current?.scrollIntoView({ behavior: "smooth" });
            isValid = false;
            handleCloseModal();
        }
        if(selectedPricesServiceProducts.length === 0 && isDailyPricesSpecificInvestment) {
            isValid = false;
            dispatch(setIsDailyPricesInvestmentError(true));
            handleCloseModal();
        }
        else {
            dispatch(setIsDailyPricesInvestmentError(false));
        }
        if(selectedPerformanceServiceProducts.length === 0 && isMonthlyPerformanceInvestmentSpecific) {
            isValid = false;
            dispatch(setIsMonthlyPerformanceInvestmentError(true));
            handleCloseModal();
        }
        else {
            dispatch(setIsMonthlyPerformanceInvestmentError(false));
        }
        if(isValid) {
            servicesAndRequest.addConsents = addConsentsRequestData;
            if(saveDailyPricesPreferences){
                if(putServiceCallForDailyPrices)
                {
                    servicesAndRequest.updateServiceStatusDaily = serviceStatusDailyPricesRequestData;
                    if(saveDailyPricesInvestmentOptions){
                        servicesAndRequest.updateServiceProductsDaily = serviceProductDailyPricesRequestData;
                    }
                }
                else
                    servicesAndRequest.deleteServiceStatusDaily = serviceStatusDailyPricesRequestData;
            }

            if(saveMonthlyPerformancePreferences){
                if(putServiceCallForMonthlyPerformance){
                    servicesAndRequest.updateServiceStatusMonthly = serviceStatusMonthlyPerformanceRequestData;
                    if(saveMonthlyPerformanceInvestmentOptions){
                        servicesAndRequest.updateServiceProductsMonthly = serviceProductMonthlyPerformanceRequestData;
                    }
                }
                else
                    servicesAndRequest.deleteServiceStatusMonthly = serviceStatusMonthlyPerformanceRequestData;
            }
            dispatchPreferencesAndSubscriptions(servicesAndRequest)
            handleCloseModal();
        }
    },[dispatch]);

    const dispatchPreferencesAndSubscriptions = useCallback((serviceAndRequest) => {
        dispatch(savePreferencesAndSubscriptions({serviceAndRequest}))
    }, [dispatch]);

    const getFooter = () => {
        return <ReactModalFooter
            tertiaryButtonText = {"Don’t Save"}
            primaryButtonText = {"Save Changes"}
            handleOnClick = {!isDisableSaveButton && !isInternal() && onClickSaveChanges}
            handleCancelClick = {()=>goBack()}
            primaryButtonId = {ANALYTICS_IDS.ConfirmModalSaveBtn}
            tertiaryButtonId={ANALYTICS_IDS.ConfirmModalDontSaveBtn}
            primaryButtonDisabled = {isDisableSaveButton}
        />
    };

    return (
        <React.Fragment>
            <BeaconModal id={modalName}
                         footer={getFooter()}>

                <ReactModalContent>
                    <ReactModalHeader modalTitle="Do you want to save your changes?"/>
                    If you don’t save, your changes will be lost.
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}

